import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import { TextAreaFormField, InputFormField } from '@playbookux/playbook-web-core';

import {
  Container,
  ContainerTitle,
  QuestionIndex,
  IconTitle,
  Title,
  Content,
  FieldSmall,
  AlignedSpan,
  SubTitle,
} from './styles';

import ErrorMessage from '../../error';

// Survey only
const FiveSecond = (props) => {
  const {
    taskIndex,
    index,
    error,
    touched,
  } = props;

  let nameFieldLabel = '';
  let nameFieldDisplayTime = '';

  nameFieldLabel = `${(taskIndex || taskIndex === 0) ? `surveysPages[${taskIndex}]` : ''}tasks.${index}.label`;
  nameFieldDisplayTime = `${(taskIndex || taskIndex === 0) ? `surveysPages[${taskIndex}]` : ''}tasks.${index}.displayTime`;

  return (
    <Container>
      <ContainerTitle>
        <QuestionIndex>{taskIndex + 1}</QuestionIndex>
        <IconTitle src="/images/question-five-second.png" />
        <Title color="questionTitleFiveSeconds">
          Five Second
        </Title>
      </ContainerTitle>

      <SubTitle>
        Instructions
      </SubTitle>

      <Field
        name={nameFieldLabel}
        component={TextAreaFormField}
      />

      <Content fluid>

        <AlignedSpan>
          Show the design for

          <FieldSmall>
            <Field
              type="number"
              name={nameFieldDisplayTime}
              size="small"
              min={5}
              max={90}
              component={InputFormField}
            />
          </FieldSmall>
          seconds.
        </AlignedSpan>
      </Content>
      <ErrorMessage
        error={error}
        touched={touched}
      />
    </Container>
  );
};

FiveSecond.propTypes = {
  question: PropTypes.shape({}).isRequired,
  error: PropTypes.shape({}).isRequired,
  touched: PropTypes.shape({}).isRequired,
  taskIndex: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

FiveSecond.defaultProps = {
};

export default React.memo(FiveSecond);
